import { render, staticRenderFns } from "./TranscribeHighlightMenu.vue?vue&type=template&id=6bb3a492&scoped=true&"
import script from "./TranscribeHighlightMenu.vue?vue&type=script&lang=js&"
export * from "./TranscribeHighlightMenu.vue?vue&type=script&lang=js&"
import style0 from "./TranscribeHighlightMenu.vue?vue&type=style&index=0&id=6bb3a492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb3a492",
  null
  
)

export default component.exports